import MemuList from '@/views/authority/memu-list.vue';
import MemuDetail from '@/views/authority/memu-detail.vue';
//菜单权限控制 2
import RoleList from '@/views/authority/role-list.vue';
import RoleDetail from '@/views/authority/role-detail.vue';
import RoleUserList from '@/views/authority/role-user-list.vue';
import RoleMenuList from '@/views/authority/role-menu-list.vue';
import RoleMenuDetail from '@/views/authority/role-menu-detail.vue';
import RoleBindMenu from '@/views/authority/role-bind-menu.vue';
import AdminUserList from '@/views/authority/admin-user-list.vue';
import AdminUserDetail from '@/views/authority/admin-user-detail.vue';
import AdminUserPassword from '@/views/authority/admin-user-password.vue';
import UserBindRole from '@/views/authority/user-bind-role.vue';

export default [
    //菜单部分
    {
        path: '/memu-list',
        component: MemuList,
        name: 'memuList'
    },
    {
        path: '/menu-list',
        component: MemuList,
        name: 'menuList'
    },
    {
        path: '/memu-detail',
        component: MemuDetail,
        name: 'memuDetail'
    },
    //角色部分
    {
        path: '/role-list',
        component: RoleList,
        name: 'roleList'
    },
    {
        path: '/role-detail',
        component: RoleDetail,
        name: 'roleDetail'
    },
    {
        path: '/role-user-list',
        component: RoleUserList,
        name: 'roleUserList'
    },
    {
        path: '/role-menu-list',
        component: RoleMenuList,
        name: 'roleMenuList'
    },
    {
        path: '/role-menu-detail',
        component: RoleMenuDetail,
        name: 'roleMenuDetail'
    },
    {
        path: '/role-bind-menu',
        component: RoleBindMenu,
        name: 'roleBindMenu'
    },
    {
        path: '/admin-user-list',
        component: AdminUserList,
        name: 'adminUserList'
    },
    {
        path: '/admin-user-detail',
        component: AdminUserDetail,
        name: 'adminUserDetail'
    },
    {
        path: '/admin-user-password',
        component: AdminUserPassword,
        name: 'adminUserPassword'
    },
    {
        path: '/user-bind-role',
        component: UserBindRole,
        name: 'userBindRole'
    },
    //角色结束
]